<template>
    <Modal
        id="add-signature-document-modal"
        ref="add-signature-document-modal"
        v-model:open="open"
        title="add_signature_document"
        width="xl"
        @cancel="cancel"
    >
        <FileUploadButton
            title="asset_signature_document"
            accept=".pdf"
            :file-name="signatureDocument.name"
            :url="signatureDocument.url"
            @submit="onSignatureDocumentUpload"
            @delete="onSignatureDocumentDelete"
        />
        <SelectField
            v-model="signatureDocument.lang"
            :label="$t('language')"
            name="signature_document_lang"
            :required="true"
            :options="languages"
        />
        <TextField
            v-if="signatureDocument.url"
            v-model="signatureDocument.signature_legal_notice"
            name="asset_signature_document_description"
            label="asset_signature_document_description"
            help="help_asset_signature_document_description"
            :rows="3"
            :required="false"
        />

        <template #actions>
            <button
                class="btn bg-primary-accent-500 text-white"
                @click="submit"
            >
                {{ $t('Create') }}
            </button>
        </template>
    </Modal>
</template>
<script setup lang="ts">
import { Modal } from '@src/components'
import SelectField from '@src/components/SelectField.vue'
import TextField from '@src/components/TextField.vue'
import { EmissionSignatureDocument } from '@src/types'
import { UploadFileResponse } from '@src/utils/api/s3'
import { useLanguageStore } from '@src/utils/stores/languages'
import { useVModels } from '@vueuse/core'
import { storeToRefs } from 'pinia'
import { reactive } from 'vue'
import FileUploadButton from '../actions/FileUploadButton.vue'

const props = defineProps<{
    open: boolean
}>()

const emit = defineEmits([
    'update:modelValue',
    'update:open',
    'cancel',
    'submit',
])

const { open } = useVModels(props, emit)

const languageStore = useLanguageStore()
const { languages } = storeToRefs(languageStore)

const signatureDocument = reactive<EmissionSignatureDocument>({
    id: null,
    uuid: null,
    signature_legal_notice: null,
    url: null,
    type: null,
    created_on: null,
    name: null,
    upload_key: null,
    lang: 'de',
})

const cancel = () => {
    emit('cancel')
}

const submit = () => {
    emit('submit', { ...signatureDocument })
    signatureDocument.name = null
    signatureDocument.upload_key = null
    signatureDocument.lang = 'de'
    signatureDocument.signature_legal_notice = null
    signatureDocument.url = null
    signatureDocument.type = null
    signatureDocument.created_on = null
}

const onSignatureDocumentUpload = (
    response: UploadFileResponse,
    fileName: string
) => {
    signatureDocument.upload_key = response.key
    signatureDocument.url = response.temp_storage_url
    signatureDocument.name = fileName
}

const onSignatureDocumentDelete = () => {
    signatureDocument.name = null
    signatureDocument.upload_key = null
    signatureDocument.lang = 'de'
}
</script>
